/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .text-list-input-hint[_ngcontent-%COMP%]{display:block;font-size:75%;color:rgba(0,0,0,.54)}"];
export { styles as styles };
